import React from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

import { Button } from "components";
import {
	DocumentsTable,
	DocumentsServiceContext,
} from "components/tables/documents";
import { applicationDocumentsService } from "services";
import { uiActions } from "store";

export declare type UnderwritingParams = {
	id: string;
	tab: string;
	merchantId: string;
};

const UnderwritingAttachments = () => {
	const params = useParams<UnderwritingParams>();
	const dispatch = useDispatch();
	const applicationId = params?.id;

	const handleAddDocument = ({ addDocument }) => {
		dispatch(
			uiActions.showModal("DOCUMENT", {
				onAddDocument(document) {
					return addDocument({ entityId: applicationId, document });
				},
			}),
		);
	};

	const handleDeleteDocument = ({ document, deleteDocument }) => {
		dispatch(
			uiActions.showModal("CONFIRMATION", {
				title: "Are you sure you want to delete the document?",
				onConfirm() {
					return deleteDocument({
						entityId: applicationId,
						documentId: document.id,
					});
				},
			}),
		);
	};

	const handleViewDocument = ({ document, viewDocument }) => {
		return viewDocument({
			entityId: applicationId,
			documentId: document.id,
		});
	};

	const handleDownLoadDocument = ({ document, downloadDocument }) => {
		return downloadDocument({
			entityId: applicationId,
			documentId: document.id,
		});
	};

	const AddDocumentButton = ({ addDocument }) => (
		<Button
			onClick={() => handleAddDocument({ addDocument })}
			value="Add New"
			className="mt-1"
		/>
	);

	return (
		<>
			<DocumentsServiceContext.Provider
				value={{
					key: ["underwritingAttachments", applicationId],
					service: applicationDocumentsService,
				}}
			>
				<DocumentsTable
					entityId={applicationId}
					AddDocumentButton={AddDocumentButton}
					onDeleteDocument={handleDeleteDocument}
					onViewDocument={handleViewDocument}
					onDownloadDocument={handleDownLoadDocument}
				/>
			</DocumentsServiceContext.Provider>
		</>
	);
};

export default UnderwritingAttachments;
